import FeedConfirmationView from "../FeedConfirmationView";
import OpenBankingFeedConfirmationView from "../OpenBankingFeedConfirmationView";
import * as _ from "lodash";
import React from "react";
import OpenBankingAccountSummaryContainer from "./components/OpenBankingAccountSummaryContainer";
import {FullStory} from "@fullstory/browser";
import * as PropTypes from "prop-types";
import OpenBankingAccountSummaryContainerForSolo from "./components/OpenBankingAccountSummaryContainerForSolo";

const FeedConfirmationResultContainer = ({
                                           source,
                                           accounts = [],
                                           selectedOnboardAccounts = [],
                                           disconnectedAccounts = [],
                                           redirectUrl,
                                           redirectToHelpPage,
                                           consumerId
                                         }) => {
  function getSummaryContent() {
    return <>
      {!_.isEmpty(selectedOnboardAccounts) &&
        <OpenBankingAccountSummaryContainer accounts={selectedOnboardAccounts} resultStatus={"selected"}/>}
      {!_.isEmpty(alreadyOnboardedAccounts) &&
        <OpenBankingAccountSummaryContainer accounts={alreadyOnboardedAccounts} resultStatus={"consentExtended"}/>}
      {!_.isEmpty(disconnectedAccounts) &&
        <OpenBankingAccountSummaryContainer accounts={disconnectedAccounts} resultStatus={"disconnectedAccounts"}/>}
      {!_.isEmpty(accountsNotYetOnboarded) &&
        <OpenBankingAccountSummaryContainer accounts={accountsNotYetOnboarded} resultStatus={"unselected"}/>}
      {!_.isEmpty(unsupportedAccounts) &&
        <OpenBankingAccountSummaryContainer accounts={unsupportedAccounts} resultStatus={"unsupportedAccounts"}/>}
    </>;
  }

  function getSummaryContentForSolo() {
    return <>
      {!_.isEmpty(selectedOnboardAccounts) &&
        <OpenBankingAccountSummaryContainerForSolo accounts={selectedOnboardAccounts} resultStatus={"selected"}/>}
      {!_.isEmpty(alreadyOnboardedAccounts) &&
        <OpenBankingAccountSummaryContainerForSolo accounts={alreadyOnboardedAccounts} resultStatus={"consentExtended"}/>}
      {!_.isEmpty(disconnectedAccounts) &&
        <OpenBankingAccountSummaryContainerForSolo accounts={disconnectedAccounts} resultStatus={"disconnectedAccounts"}/>}
      {!_.isEmpty(accountsNotYetOnboarded) &&
        <OpenBankingAccountSummaryContainerForSolo accounts={accountsNotYetOnboarded} resultStatus={"unselected"}/>}
      {!_.isEmpty(unsupportedAccounts) &&
        <OpenBankingAccountSummaryContainerForSolo accounts={unsupportedAccounts} resultStatus={"unsupportedAccounts"}/>}
    </>;
  }

  const isFromSolo = consumerId === "Solo";
  const accountsNotYetOnboarded = _.filter(accounts, account => !account.onboarded && !account.unsupportedDescription && !_.includes(selectedOnboardAccounts, account));
  const alreadyOnboardedAccounts = _.filter(accounts, account => account.onboarded);
  const unsupportedAccounts = _.filter(accounts, account => account.unsupportedDescription);


  const getOpenBankingSummarySection = () => {
    if (_.every(accounts, account => account.onboarded && !account.unsupportedDescription)) {
      FullStory('trackEvent', {
        name: 'Onboard Finalise Confirmation',
        properties: {
          status: "alreadyOnboarded",
          source: source
        },
      })
    }

    if (_.isEmpty(accountsNotYetOnboarded)) {
      FullStory('trackEvent', {
        name: 'Onboard Finalise Confirmation',
        properties: {
          status: "allSuccess",
          source: source
        },
      })} else {
      FullStory('trackEvent', {
        name: 'Onboard Finalise Confirmation',
        properties: {
          status: "selectedSuccess",
          source: source
        },
      })
    }

    return isFromSolo ? getSummaryContentForSolo() : getSummaryContent()
  }

  const isOpenBanking = source?.toLowerCase() === "openbanking";

  return isOpenBanking ? (
    <OpenBankingFeedConfirmationView
      summarySection={getOpenBankingSummarySection()}
      redirectUrl={redirectUrl}
      redirectToHelpPage={redirectToHelpPage}
      consumerId={consumerId}
    />
  ) : (
    <FeedConfirmationView
      accountData={selectedOnboardAccounts}
      redirectUrl={redirectUrl}
    />
  );
}

FeedConfirmationResultContainer.propTypes = {
  source: PropTypes.string,
  accounts: PropTypes.array,
  selectedOnboardAccounts: PropTypes.array,
  disconnectedAccounts: PropTypes.array,
  redirectUrl: PropTypes.string,
  redirectToHelpPage: PropTypes.func,
  consumerId: PropTypes.string
};

export default FeedConfirmationResultContainer;
